import { blue } from '@mui/material/colors';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../assets/scripts/chart.umd.min.js';
const chartId = 'history-chart';
function BikeStationHistoryChart({
  bikeStation,
  history
}) {
  const chartRef = useRef(null);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const {
      Chart,
      CategoryScale,
      LinearScale,
      BarController,
      BarElement,
      Tooltip
    } = window.Chart;
    Chart.register(CategoryScale, LinearScale, BarController, BarElement, Tooltip);
    Chart.defaults.font.family = '"Roboto", "Helvetica", "Arial", sans-serif';
  }, []);
  useEffect(() => {
    let _chart;
    if (chartRef.current && history) {
      const {
        Chart
      } = window.Chart;
      const {
        capacity
      } = bikeStation;
      _chart = new Chart(chartRef.current, {
        type: 'bar',
        data: {
          labels: history.map(({
            date
          }) => date.format('lll')),
          datasets: [{
            label: t('commons.bike_stations.bikes') || '',
            data: history.map(({
              availableClassicBikes
            }) => availableClassicBikes),
            backgroundColor: blue[900]
          }, {
            label: t('commons.bike_stations.e-bikes') || '',
            data: history.map(({
              availableEBikes
            }) => availableEBikes),
            backgroundColor: blue[500]
          }, {
            label: t('commons.bike_stations.slots') || '',
            data: history.map(({
              availableLots
            }) => availableLots),
            backgroundColor: blue[100]
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            x: {
              stacked: true,
              ticks: {
                callback: (_, index) => history[index].date.format('LT')
              }
            },
            y: {
              beginAtZero: true,
              max: capacity,
              stacked: true
            }
          },
          interaction: {
            mode: 'index'
          }
        }
      });
    }
    return () => {
      if (_chart) _chart.destroy();
    };
  }, [history, chartRef.current]);
  return /*#__PURE__*/React.createElement("canvas", {
    height: 130,
    id: chartId,
    ref: chartRef,
    style: {
      marginTop: 16,
      width: '100%'
    }
  });
}
export default BikeStationHistoryChart;